module.exports = __webpack_public_path__ + "static/img/z-3.ef2a01b0.png";